export const ICONCLASS = {
  "0": "Abstract, Non-representational Art",
  "1": "Religion and Magic",
  "2": "Nature",
  "3": "Human Being, Man in General",
  "4": "Society, Civilization, Culture",
  "5": "Abstract Ideas and Concepts",
  "6": "History",
  "7": "Bible",
  "8": "Literature",
  "9": "Classical Mythology and Ancient History"
};


export const SECTIONS = [{ key: "all", color: "#444", text: "All content" }];